module.exports = __webpack_public_path__ + "static/img/lscjzm.589111f6.png";